import type { ReasonSubtype, ReasonType } from "@/api/returns";

/** Причина приёмки возврата человеческим текстом.
 *
 * Одна на весь фронт: причину показывают и в приёмке (лента позиций), и в
 * обработке (разбор нехваток), и второй словарь означал бы, что одна и та же
 * позиция называется в двух местах по-разному.
 *
 * `reason_subtype` заполняется только у утиля — у переупаковки и «на ФБС» его
 * нет по модели, поэтому имя берётся из типа.
 */
export function reasonLabel(
  type: ReasonType | string,
  subtype: ReasonSubtype | string | null,
): string {
  if (type === "repack") return "Переупаковка";
  if (type === "fbs") return "На ФБС";
  if (subtype === "expired") return "Просрочка";
  if (subtype === "illiquid") return "Неликвид";
  if (subtype === "incomplete") return "Некомплект";
  return "Утиль";
}

/** Цвет плашки причины: утиль красный, переупаковка синяя, «на ФБС» зелёная —
 *  так же, как кнопки на экране приёмки, чтобы причина узнавалась по цвету. */
export function reasonTone(type: ReasonType | string): string {
  if (type === "repack") return "bg-sky-100 text-sky-900";
  if (type === "fbs") return "bg-emerald-100 text-emerald-900";
  return "bg-red-100 text-red-900";
}

/** Кнопки причины на экране приёмки (порядок = порядок на экране). */
export const REASON_BUTTONS: {
  label: string;
  reason_type: ReasonType;
  reason_subtype: ReasonSubtype | null;
  cls: string;
}[] = [
  { label: "Просрочка", reason_type: "utility", reason_subtype: "expired", cls: "bg-red-600 text-white" },
  { label: "Неликвид", reason_type: "utility", reason_subtype: "illiquid", cls: "bg-red-600 text-white" },
  { label: "Некомплект", reason_type: "utility", reason_subtype: "incomplete", cls: "bg-red-600 text-white" },
  { label: "Переупаковка", reason_type: "repack", reason_subtype: null, cls: "bg-sky-700 text-white" },
  // Целый товар — сразу на склад ФБС того же юрлица, без СЗ. Пятая кнопка —
  // на всю ширину сетки 2×N, чтобы не висела половинкой.
  { label: "На ФБС", reason_type: "fbs", reason_subtype: null, cls: "col-span-2 bg-emerald-700 text-white" },
];
